import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Notification } from '@aid/notifications/types/classes';
import { NotificationIconService } from '@aid/notifications/services';

@Component({
  selector: 'aid-notification-item',
  template: `
    <div
      class="notification-item aid-layout-row aid-layout-align-start-center aid-layout-gap-12"
      (click)="onSelect()"
    >
      @if (!boundNotification.read) {
        <div class="not-read"></div>
      }

      <div class="icon-container aid-layout-row aid-layout-align-center-center">
        <mat-icon class="icon-container__size" [svgIcon]="icon"></mat-icon>
      </div>

      <div>
        <div class="mat-subtitle-2">
          {{ boundNotification.title | translate }}
        </div>
        <div class="mat-subtitle-2">
          {{ boundNotification.message }}
        </div>
        <div class="mat-caption date">
          {{ boundNotification.created | date: 'short' }}
        </div>
      </div>

      <div class="actions aid-layout-inline-gap-4">
        <button
          class="actions__button"
          mat-icon-button
          (click)="onRemove(); $event.stopPropagation()"
        >
          <mat-icon class="actions__icon" svgIcon="delete"></mat-icon>
        </button>

        <button
          class="actions__button aid-layout-row aid-layout-align-center-center"
          mat-icon-button
          (click)="onRead(); $event.stopPropagation()"
        >
          <div
            class="actions__read"
            [ngClass]="{ 'not-read-color': !boundNotification.read }"
          ></div>
        </button>
      </div>
    </div>
    @if (!last) {
      <mat-divider></mat-divider>
    }
  `,
  styleUrls: ['./notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NotificationItemComponent implements OnInit {
  @Input() notification?: Notification;
  @Input() last?: boolean;

  @Output() select = new EventEmitter();
  @Output() remove = new EventEmitter();
  @Output() read = new EventEmitter();
  @Output() unread = new EventEmitter();

  constructor(private notificationIconService: NotificationIconService) {}

  ngOnInit() {}

  get icon() {
    return this.notificationIconService.getIcon(this.boundNotification);
  }

  onSelect() {
    this.select.emit(this.notification);
  }

  onRemove() {
    this.remove.emit();
  }

  onRead() {
    if (this.boundNotification.read) {
      return this.unread.emit();
    }
    return this.read.emit();
  }

  get boundNotification(): Notification {
    if (!this.notification) {
      throw new Error('aid-notification-item: no notification is bound.');
    }
    return this.notification;
  }
}
